<template>
	<div>
		<slot :data="appData"></slot>
	</div>
</template>
<script>
	export default {
		props:{
			data:{
				default:null
			}
		},
		
		data(){
			return {
				appData: [],
			}
		},

		mounted() {
			document.addEventListener("DOMContentLoaded", (e) => {
				this.appData = window.App;
			})
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ProLitApp.vue